import React from "react";
import WorkTimeline from "./components/WorkTimeline";
import "./styles.css";
import Header from "./components/Header";
import Particles from "react-tsparticles";
import particlesConfig from "./misc/particlesconfig";
import Footer from "./components/Footer";
import Documents from "./components/Documents";
import Team from "./components/Team";
import NavBar from "./components/NavBar";

function App() {
  return (
    <div>
      <NavBar/>
      <div className="text-center d-flex align-items-center justify-content-center mt-5">
        <Particles id="tsparticles" options={particlesConfig} />
        <div className="bg-white position-fix contentWindow mb-5 mt-5">
          <Header />  
          <Team/>
          <WorkTimeline />
          <Documents />
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
